import React, { useState } from "react";
import { Soup, LogIn, LogOut } from "lucide-react";
import { toast } from "sonner";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

const TABS = [
  { id: "input", label: "Input Rekap", testid: "nav-tab-recap-input" },
  { id: "lembur_input", label: "Input Lembur", testid: "nav-tab-lembur-input" },
  { id: "dashboard", label: "Laporan", testid: "nav-tab-dashboard" },
  { id: "history", label: "Riwayat", testid: "nav-tab-history" },
  { id: "gaji", label: "Gaji", testid: "nav-tab-gaji" },
  { id: "teams", label: "Kelola Peserta", testid: "nav-tab-teams", admin: true },
  { id: "pinjaman", label: "Hutang", testid: "nav-tab-pinjaman", admin: true },
  { id: "barang", label: "Kelola Barang", testid: "nav-tab-barang", master: true },
];

export const Navbar = ({ active, onChange, isAdmin, adminUser, onLogin, onLogout }) => {
  const [open, setOpen] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await onLogin(username, password);
      toast.success("Berhasil login sebagai admin");
      setOpen(false);
      setUsername("");
      setPassword("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login gagal");
    } finally {
      setLoading(false);
    }
  };

  const isMaster = adminUser?.role === "master";
  const tabs = TABS.filter((t) => (!t.admin || isAdmin) && (!t.master || isMaster));

  return (
    <header
      data-testid="app-navbar"
      className="no-print sticky top-0 z-50 bg-white/85 backdrop-blur-xl border-b-2 border-stone-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-3.5">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-2.5">
            <div className="grid place-items-center w-11 h-11 rounded-2xl bg-rose-600 text-white shadow-md">
              <Soup className="w-6 h-6" />
            </div>
            <div className="leading-tight">
              <p className="font-display font-black text-lg sm:text-xl text-stone-900">
                Dimsum 1000 Official
              </p>
              <p className="text-xs font-semibold text-stone-500 -mt-0.5">
                Rekap Pekerjaan Harian
              </p>
            </div>
          </div>
          {isAdmin ? (
            <button
              data-testid="admin-logout-btn"
              onClick={onLogout}
              className="shrink-0 inline-flex items-center gap-2 min-h-[44px] rounded-2xl bg-stone-100 hover:bg-stone-200 text-stone-800 font-bold px-4 text-sm transition-colors"
            >
              <LogOut className="w-4 h-4" />
              <span className="hidden sm:inline">Logout {adminUser?.username ? `(${adminUser.username})` : ""}</span>
              <span className="sm:hidden">Keluar</span>
            </button>
          ) : (
            <button
              data-testid="admin-login-btn"
              onClick={() => setOpen(true)}
              className="shrink-0 inline-flex items-center gap-2 min-h-[44px] rounded-2xl bg-rose-600 hover:bg-rose-700 text-white font-bold px-4 text-sm shadow-md transition-colors"
            >
              <LogIn className="w-4 h-4" /> Login
            </button>
          )}
        </div>
        <nav className="mt-3 flex gap-1.5 overflow-x-auto pb-1">
          {tabs.map((t) => (
            <button
              key={t.id}
              data-testid={t.testid}
              onClick={() => onChange(t.id)}
              className={`min-h-[48px] whitespace-nowrap rounded-2xl px-5 py-2.5 text-base font-bold transition-colors ${
                active === t.id
                  ? "bg-rose-600 text-white shadow-md"
                  : "bg-stone-100 text-stone-700 hover:bg-stone-200"
              }`}
            >
              {t.label}
            </button>
          ))}
        </nav>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="admin-login-dialog">
          <DialogHeader>
            <DialogTitle>Login</DialogTitle>
          </DialogHeader>
          <form onSubmit={submit} className="space-y-3">
            <input
              type="text"
              autoComplete="username"
              data-testid="login-username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Username"
              className="w-full min-h-[44px] rounded-xl border-2 border-stone-200 px-3 font-semibold"
            />
            <input
              type="password"
              autoComplete="current-password"
              data-testid="login-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              className="w-full min-h-[44px] rounded-xl border-2 border-stone-200 px-3 font-semibold"
            />
            <button
              type="submit"
              data-testid="login-submit"
              disabled={loading}
              className="w-full min-h-[44px] rounded-xl bg-rose-600 hover:bg-rose-700 text-white font-bold shadow-md disabled:opacity-40 transition-colors"
            >
              {loading ? "Memproses…" : "Masuk"}
            </button>
          </form>
        </DialogContent>
      </Dialog>
    </header>
  );
};
